import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { ApiUrlConstant } from "./../../../../constants/api-url.constant";
import { Observable } from "rxjs";

@Injectable()
export class TransportationNuclearStockpilesService {
  baseUrl = environment.gateWayHost;
  editItem: any;
  constructor(
    public generic: GenericHttpService,
    private apiUrl: ApiUrlConstant
  ) {}

  getData(options): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.baseUrl}${options.url}`,
      query: options.params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processData)
    );
  }
  processData(data: any) {
    if (data.data.length === 0) return null;
    const NewchartData: any = [
      {
        name: "Hard copy",
        data: [],
        color: "#8bc9fb"
      },
      {
        name: "Soft copy",
        data: [],
        color: "#007fd8"
      },
      {
        name: "Target",
        data: [],
        type: "line",
      }
    ];
    data.data[0].TransportationPODAvailability.forEach(value => {
      NewchartData[0].data.push(value.hard_copy);
      NewchartData[1].data.push(value.soft_copy);
    });
    return NewchartData;
  }

  createChart(chartData, Options) {
    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    chart.series = chartData;
    return chart;
  }
}
